export default __webpack_public_path__ + "static/media/braces-invisiveis.c656d04e.png";